import { useSelector } from "react-redux";
import { toggleStatusItem } from "./customerInteractionAdmin/useReviewsFilters";
import CustomerReviewFiltersAction from "@common/redux/actions/CustomerReviewFiltersAction";
import CustomerReviewAction from "@common/redux/actions/CustomerReviewAction";
import CustomerAction from "@common/redux/actions/CustomerAction";
import useCustomerReviewModal from "./customerInteractionAdmin/useCustomerReviewModal";
import CustomerReviewModalAction from "@common/redux/actions/CustomerReviewModalAction";
import { mapStatusCounts } from "../helpers/forms";

const useCustomerReviewsFilters = () => {
  const { currentTab } = useCustomerReviewModal();

  const data = useSelector((state) =>
    CustomerReviewFiltersAction.getStatePath(state),
  );  

  const modalState = useSelector((state) =>
    CustomerReviewModalAction.getStatePath(state)
  );

  const reviewStatusCounts = mapStatusCounts(modalState?.selectedCustomerReviews?.reviewStatusCounts || []);
  const { reviewStatusIds } = modalState;

  const setState = CustomerReviewFiltersAction.dispatch;
  const setCustomerState = CustomerAction.dispatch;

  const onDatesChange = (event, { name, value }) => {
    const fnSetState = currentTab === 1 ? setCustomerState : setState;
    fnSetState({ [name]: value, pageNumber: 1 });
  };

  const onInputChange = (_, { name, value }) => setState({ [name]: value });

  const onStatusChange = (id) => {
    const toggled = toggleStatusItem(id, reviewStatusIds);

    const newStatusIds =
      toggled.length > 0 ? toggled : reviewStatusCounts.map((x) => x.key);
      // CustomerReviewModalAction.dispatch({ reviewStatusIds: newStatusIds, pageNumber: 1 });
  };

  const toggleFilters = () => {
    setState({ showFilters: !data?.showFilters });
  };

  return {
    ...data,
    reviewStatusCounts,
    onDatesChange,
    onInputChange,
    onStatusChange,
    setState,
    toggleFilters,
  };
};

export default useCustomerReviewsFilters;
